import React from 'react'
// import Lottie from "lottie-react";
// import animationData from "./animation.json";

const InnerLoader = ({ textStatus = true, text = "Data Load...", className, wrapperClass, style }) => {
    return (
        <div className={`tableDataLoader ${wrapperClass}`}>
            <div className="tableDataLoader-wrapper">
                <div className={`loader ${className}`} style={style}></div>
                {
                    textStatus ? (
                        <span>{text}</span>
                    ) : (
                        null
                    )
                }
                {/* <Lottie animationData={animationData} loop={true} /> */}
            </div>
        </div>
    )
}

export default InnerLoader
